import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "../../../CommonUtils/CommonUrl/CommonUrls";
import Header from "../../../Header/Header";
import { CommonAxiosGet } from "../../../CommonUtils/CommonAxios/CommonAxios";
export default function AloMappedMandalsReport() {
  let navigate = useNavigate();
  const location = useLocation();
  const data = location?.state?.data;
  const [AloMappedMandals, setAloMappedMandals] = useState([]);
  function GetAloMappedMandals() {
    const URLL = `${config.url.BOC_URL}alomandals/${data?.org_id}`;
    CommonAxiosGet(URLL).then((res) => {
      if (res?.data.status === true) {
        setAloMappedMandals(res?.data.alcoMandals);
      }
    });
  }

  useEffect(() => {
    GetAloMappedMandals();
  }, []);
  return (
    <>
      <Header />
      <div className="main_section"> </div>

      <Container>
        <Row>
          <Col
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="page-titlespacing d-flex justify-content-between"
          >
            <div className="inner-herbpage-service-title1">
              <h1><span style={{ color: "brown" }}>{data.org_name}</span> - ALO  Wise Mapped Mandals Report</h1>
            </div>
            <div className="text-right">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => { navigate(-1); }}
              >
                Back
              </button>
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="outer-page-content-container">
        <Row className="px-4">
          <center>
            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
              style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
            >
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Mandal Name</th>
                </tr>
              </thead>
              <tbody>
                {AloMappedMandals &&
                  AloMappedMandals?.map((data, i) => {
                    return (
                      <tr key={i}>
                        <td style={{ textAlign: "center" }}>{i + 1}</td>
                        <td style={{ textAlign: "center" }}>
                          {data.mandal_name}
                        </td>

                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </center>
        </Row>
      </Container>

    </>
  );
}
